<template>
    <section>

        <h1 style="margin-bottom: 20px">{{ activeTab === 'welcome' ? 'Welcome' : 'Scansioni' }}</h1>

        <!-- NAV dei tab -->
        <div class="tabs">
            <button
                class="tab"
                :class="{ active: activeTab === 'welcome' }"
                @click="activeTab = 'welcome'"
            >
                Welcome
            </button>
            <button
                class="tab"
                :class="{ active: activeTab === 'scansioni' }"
                @click="activeTab = 'scansioni'"
            >
                Scansioni ({{ filteredScans.length }})
            </button>
        </div>

        <!-- CONTENUTI dei tab -->
        <div class="tab-content">
            <!-- Tab Welcome -->
            <div v-if="activeTab === 'welcome'" class="tab-panel">
                <div class="box grey-box">

                    <h2>Inclusione</h2>

                    <div class="content">
                        Script di inclusione nel booking engine:<br /><br />

                        <pre class="code-block">
<code>
&lt;script id='cookieScriptInclusion'
defer
type='text/javascript'
src='https://bulpublic.blastness.com/init.js?v=2&l=[ita|eng|fra...]'&gt;
&lt;/script&gt;
</code>
</pre>

                    </div>
                </div>
            </div>

            <!-- Tab Scansioni -->
            <div v-if="activeTab === 'scansioni'" class="tab-panel">
                <div class="box">
                    <div class="table__header">

                        <div class="table__header_filters">

                            <!-- AUTOCOMPLETE PROGETTI -->
                            <div class="table__header_filters_sx">
                                <div ref="autocompleteContainer" style="position: relative;">
                                    <input
                                        v-model="projectSearch"
                                        @focus="showProjectList = true"
                                        @input="onProjectInput"
                                        placeholder="Cerca progetto..."
                                        class="input_filter"
                                    />

                                    <!-- DROPDOWN PROGETTI -->
                                    <ul
                                        v-if="showProjectList && filteredProjects.length"
                                        style="
                        position: absolute;
                        top: 35px;
                        left: 0;
                        width: 100%;
                        max-height: 200px;
                        overflow-y: auto;
                        background: white;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        list-style: none;
                        margin: 0;
                        padding: 0;
                        z-index: 999;
                      "
                                    >
                                        <li
                                            v-for="p in filteredProjects"
                                            :key="p.id"
                                            @click="selectProject(p)"
                                            style="padding: 5px 8px; cursor: pointer;"
                                        >
                                            {{ p.project }} ({{ scansCountByProject[p.id] }})
                                        </li>
                                    </ul>
                                </div>
                                <select v-model="selectedStatus" class="input_filter_1">
                                    <option value="">Tutte le azioni</option>
                                    <option value="associazione">Associazione</option>
                                    <option value="suggerimento">Suggerimento</option>
                                </select>
                                <select v-model="domainFilterMode" class="input_filter_1">
                                    <option value="tutti">Tutti i domini</option>
                                    <option value="siti">Siti</option>
                                    <option value="www.blastnessbooking.com">www.blastnessbooking.com</option>
                                    <option value="book.blastness.com">book.blastness.com</option>
                                </select>
                            </div>
                            <div class="table__header_filters_dx">
                                <div class="button button-p" style="line-height: 30px" @click="truncateAssociations()">
                                    <i class="fal fa-trash" style="font-size: 16px !important; margin-right: 5px;"></i>
                                    Cancella associzioni
                                </div>
                                <div class="button button-p" style="line-height: 30px" @click="truncateScans()">
                                    <i class="fal fa-trash" style="font-size: 16px !important; margin-right: 5px"></i>
                                    Svuota scansioni
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- TABELLA -->
                    <div class="table__content">

                        <div class="tableWrapper">
                            <table class="elementTable">
                                <thead>
                                <tr>
                                    <th><input type="checkbox" @change="toggleSelectAll($event)" :checked="allSelected"></th>
                                    <th></th>
                                    <th>ProjectID</th>
                                    <th>Library</th>
                                    <th>Name</th>
<!--                                    <th>Domain</th>-->
                                    <th>Href</th>
                                    <th>FoundData</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="scan in filteredScans" :key="scan.id">
                                    <td><input type="checkbox" :value="scan.id" v-model="selectedScanIds"></td>
                                    <td>
                                        <span
                                            :style="{
    display: 'block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: scan.library_id !== null ? 'green' : 'orange',
    marginRight: '5px'
  }"
                                        ></span>
                                    </td>
                                    <td>{{ scan.project_id }}</td>
                                    <td>{{ scan.library_id !== null ? scan.library : '' }}</td>
                                    <td class="truncate" :title="scan.name">{{ scan.name }}</td>
<!--                                    <td class="truncate" :title="scan.domain">{{ scan.domain }}</td>-->
                                    <td>
                                        <div style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="scan.href">
                                            {{ scan.href }}
                                        </div>
                                    </td>
                                    <td class="truncate">{{ scan.created_at }}</td>
                                    <td class="action">

                                        <div class="actions">
                                            <!-- Import Modal -->
                                            <a v-if="scan.library_id === null" class="button icon btn_success" @click.stop="openLibraryModal(scan)">
                                                <i class="fal fa-file-import"></i>
                                            </a>

                                            <!-- Blacklist solo per Suggerimento -->
                                            <a v-if="scan.library_id === null" class="button icon btn_warning" @click.stop="blacklistCookie(scan.name)" title="Metti in blacklist">
                                                <i class="fal fa-ban"></i>
                                            </a>

                                            <!-- Delete -->
                                            <a class="button icon btn_danger" @click.stop="markRead(scan.id)">
                                                <i class="fal fa-trash-alt"></i>
                                            </a>

                                        </div>

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- AZIONI MULTIPLE -->
                    <div class="multi-actions">
                        <button class="button-alt" @click="multiDelete">
                            <i class="fal fa-trash-alt"></i>
                        </button>
                        <div>
                            Metti in blacklist {{ selectedScanIds.length }} elementi
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <!-- MODALE LIBRARYFORM -->
        <div v-if="libraryModal" class="modal-overlay" @click.self="libraryModal = false">
            <div class="modal">

                <!-- HEADER -->
                <div class="modal-header">
                    <span class="headline">Library Form</span>
                    <button class="close-btn" @click="libraryModal = false">
                        <i class="fal fa-times"></i>
                    </button>
                </div>

                <!-- BODY -->
                <div class="modal-body">
                    <LibraryForm
                        :key="nameSelected"
                        :action="'create'"
                        :from-scan-name="nameSelected"
                        open-type="modal"
                        @saved="onLibrarySaved"
                    />
                </div>

            </div>
        </div>

    </section>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import LibraryForm from "@/views/modules/Libraries/form.vue";

export default {
    name: "Dashboard",
    components: { LibraryForm },
    data() {
        return {
            activeTab: "welcome",
            libraryModal: false,
            nameSelected: null,
            selectedProject: "",
            selectedStatus: "",
            domainFilterMode: "tutti",
            selectedScanIds: [],
            projectSearch: "",
            showProjectList: false,
        };
    },
    computed: {
        ...mapGetters("dashboardModule", ["scans", "projects"]),

        filteredScans() {
            let result = this.scans;
            if (this.selectedProject) result = result.filter(s => s.project_id == this.selectedProject);
            if (this.selectedStatus === "associazione") result = result.filter(s => s.library_id !== null);
            else if (this.selectedStatus === "suggerimento") result = result.filter(s => s.library_id === null);

            const excluded = ["www.blastnessbooking.com", "book.blastness.com"];
            if (this.domainFilterMode === "siti") result = result.filter(s => s.domain && !excluded.includes(s.domain));
            else if (this.domainFilterMode === "www.blastnessbooking.com") result = result.filter(s => s.domain === "www.blastnessbooking.com");
            else if (this.domainFilterMode === "book.blastness.com") result = result.filter(s => s.domain === "book.blastness.com");

            return result;
        },

        scansCountByProject() {
            const counts = {};
            this.projects.forEach(p => (counts[p.id] = 0));
            this.scans.forEach(s => {
                if (counts[s.project_id] !== undefined) counts[s.project_id]++;
            });
            return counts;
        },

        allSelected() {
            return this.filteredScans.length && this.selectedScanIds.length === this.filteredScans.length;
        },

        filteredProjects() {
            return this.projects.filter(p =>
                p.project.toLowerCase().includes(this.projectSearch.toLowerCase()) &&
                (this.scansCountByProject[p.id] || 0) > 0
            );
        }
    },

    mounted() {
        document.addEventListener("click", this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleOutsideClick);
    },

    methods: {
        handleOutsideClick(e) {
            if (this.$refs.autocompleteContainer && !this.$refs.autocompleteContainer.contains(e.target)) {
                this.showProjectList = false;
            }
        },

        onProjectInput() {
            this.showProjectList = true;
            if (this.projectSearch === "") this.selectedProject = "";
        },

        selectProject(p) {
            this.selectedProject = p.id;
            this.projectSearch = p.project;
            this.showProjectList = false;
        },

        toggleSelectAll(event) {
            if (event.target.checked) this.selectedScanIds = this.filteredScans.map(s => s.id);
            else this.selectedScanIds = [];
        },

        openLibraryModal(scan) {
            this.nameSelected = scan.name;
            this.libraryModal = true;
        },

        async truncateScans() {
            try {
                if (confirm("Svuota le scansioni?")) {
                    await axios.get(`${process.env.VUE_APP_API_URL}truncateScans`);
                    this.$store.commit("dashboardModule/truncateScans");
                }
            } catch (error) {
                console.error("Errore:", error);
            }
        },

        async markRead(id) {
            try {
                await axios.patch("dashboard/read/" + id, {});
                this.loadDashboardData();
            } catch (e) {
                console.error("Errore DELETE:", e);
            }
        },

        async multiDelete() {
            if (!this.selectedScanIds.length) return;
            try {
                await axios.post("/delete-scans", { ids: this.selectedScanIds });
                this.loadDashboardData();
            } catch (e) {
                console.error("Errore DELETE:", e);
            }
        },

        async loadDashboardData() {
            await this.$store.dispatch("dashboardModule/loadDashboardData", { urlToConnect: "dashboard" });
            this.selectedScanIds = [];
        },

        onLibrarySaved() {
            this.libraryModal = false;
            this.loadDashboardData();
        },

        async truncateAssociations() {
            if (!confirm("Vuoi cancellare i log delle associazioni" +
            (this.selectedProject ? " per questo progetto?" : "?"))) return;
            try {
                await axios.post(`/delete-associations`, { projectId: this.selectedProject });
                this.loadDashboardData();
            } catch (error) {
                console.error("Errore nel cancellare le scansioni del progetto:", error);
            }
        },

        async blacklistCookie(name) {
            if (!confirm(`Vuoi mettere in blacklist il cookie "${name}"?`)) return;
            try {
                await axios.post('/blacklist-cookie', { cookieName: name });
                this.loadDashboardData();
            } catch (error) {
                console.error("Errore nella blacklist:", error);
                alert("Errore durante l'aggiunta alla blacklist");
            }
        }

    },

    created() {
        this.loadDashboardData();
    }
};
</script>
